import React, { useState } from "react";
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  IconButton,
  InputAdornment,
  Box,
} from "@mui/material";
import axios from "axios";

export default function AdminLogin() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [token, setToken] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [selectedReport, setSelectedReport] = useState<string | null>(null);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    try {
      const res = await axios.post("https://csp-tracking-api.drishtee.in/api/login", {
        username,
        password,
      });

      if (res.data.token) {
        setToken(res.data.token);
      } else {
        setError("Login failed: No token received");
      }
    } catch (err: any) {
      console.error("Login error:", err);
      setError("Invalid username or password");
    }
  };

  if (!token) {
    return (
      <Container maxWidth="xs">
        <Paper sx={{ p: 4, mt: 8 }}>
          <Typography variant="h6" gutterBottom>
            Admin Login
          </Typography>
          <form onSubmit={handleLogin}>
            <TextField
              fullWidth
              label="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              margin="normal"
              required
            />

            <TextField
              fullWidth
              type={showPassword ? "text" : "password"}
              label="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              margin="normal"
              required
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                    >
                      {showPassword ? "🔓" : "🔒"}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              sx={{ mt: 2 }}
            >
              Login
            </Button>
            {error && (
              <Typography color="error" sx={{ mt: 2 }}>
                {error}
              </Typography>
            )}
          </form>
        </Paper>
      </Container>
    );
  }

  // Power BI report links
  const reports = {
    report1:
"https://app.powerbi.com/view?r=eyJrIjoiZDIzNjY0NDgtNmE1MS00Mjg3LWFlZjctYjJiYTZlZTgzMjVlIiwidCI6IjhkMmMwODMyLWVkZWQtNGQ5My05NGZmLTFjZDIxMDFlYzAwNCJ9",
    report2:
"https://app.powerbi.com/view?r=eyJrIjoiMmM2ZjJmZDEtY2ZiMi00YmZjLTliNWUtYTBiZDhkZWYyZDU5IiwidCI6IjhkMmMwODMyLWVkZWQtNGQ5My05NGZmLTFjZDIxMDFlYzAwNCJ9",
  };

  return (
    <Box sx={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      {/* Buttons to toggle reports */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 2,
          p: 2,
          backgroundColor: "#f5f5f5",
        }}
      >
        <Button
          variant={selectedReport === reports.report1 ? "contained" : "outlined"}
          color="primary"
          onClick={() => setSelectedReport(reports.report1)}
        >
          Show Report 1
        </Button>

        <Button
          variant={selectedReport === reports.report2 ? "contained" : "outlined"}
          color="secondary"
          onClick={() => setSelectedReport(reports.report2)}
        >
          Show Report 2
        </Button>
      </Box>

      {/* Show iframe if a report is selected */}
      {selectedReport && (
        <iframe
          src={selectedReport}
          width="100%"
          height="100%"
          style={{ border: "none", flexGrow: 1 }}
          allowFullScreen
        />
      )}
    </Box>
  );
}
